import {
  Component,
  createSignal,
  createMemo,
  createEffect,
  For,
} from 'solid-js';
import { t } from '@trimble/i18n';
import { LINE_STYLES } from '../utils/layer-default-values';
import { closeDropdown } from '../utils/dropdown-utils';

export interface LineStyleSelectorProps {
  initialLineStyle: string;
  onLineStyleChange(lineStyle: string): void;
}

export const LineStyleSelector: Component<LineStyleSelectorProps> = (props) => {
  let lineStyleDropdownWrapper: HTMLDivElement | undefined;

  const [currentLineStyle, setCurrentLineStyle] = createSignal<string>(
    props.initialLineStyle
  );

  createEffect(() => {
    setCurrentLineStyle(props.initialLineStyle);
  });

  const handleLineStyleChange = (lineStyle: string): void => {
    if (lineStyle === currentLineStyle()) {
      closeDropdown(lineStyleDropdownWrapper);
      return;
    }
    setCurrentLineStyle(lineStyle);
    props.onLineStyleChange(lineStyle);
    closeDropdown(lineStyleDropdownWrapper);
  };

  const selectedLineStyle = createMemo(() => {
    return LINE_STYLES.find((style) => style.value === currentLineStyle());
  });

  return (
    <div
      class="flex flex-col gap-1 flex-1"
      ref={(el) => {
        lineStyleDropdownWrapper = el;
      }}
    >
      <label class="text-xs text-gray-6">{t('general.linestyle')}</label>
      <div class="border border-gray-2 rounded-md">
        <modus-wc-dropdown-menu
          button-variant="borderless"
          button-color="tertiary"
          menu-placement="bottom-end"
          class="w-full block rounded-md [&_modus-wc-button]:!w-full [&_modus-wc-button]:!block [&_button]:!w-full"
          disabled={false}
        >
          <div
            slot="button"
            class="flex items-center py-0.5 text-xs w-full justify-between"
          >
            <div class="flex items-center gap-2.5">
              <modus-wc-icon
                size="sm"
                name={selectedLineStyle()?.icon || 'polygon_line_tool'}
              />
              <span class="text-gray-7">
                {selectedLineStyle()?.label || currentLineStyle() || 'Solid'}
              </span>
            </div>
            <modus-wc-icon name="expand_more" size="sm" />
          </div>
          <div slot="menu">
            <For each={LINE_STYLES}>
              {(style) => (
                <modus-wc-menu-item
                  class="text-gray-7"
                  size="md"
                  label={style.label}
                  value={style.value}
                  on:itemSelect={(event) => {
                    const e = event as CustomEvent<{ value: string }>;
                    handleLineStyleChange(e.detail.value);
                  }}
                />
              )}
            </For>
          </div>
        </modus-wc-dropdown-menu>
      </div>
    </div>
  );
};
